import React, { useContext } from "react";
import { Flex, Layout } from "antd";
import {
  HeaderComp,
  FooterComp
} from '../../../../components'
import Full from '../../../../components/Accordion/Full'
import { LangContext } from "../../../../utils/LanguageProvider";
const { Header, Content, Footer } = Layout

const Faqs = () => {
  const { lang } = useContext(LangContext);
  return (
    <>
      <Header>
        <div className="header-container">
          <HeaderComp />
        </div>
      </Header>
      <div className="full-container">
        <Flex vertical style={{ maxWidth: '1400px', width: '100%' }}>
          <Content className="global-content">
            <Full page={"faqs"} section={"pagos-recibos"} lang={lang} queryType={"faqs"}/>
            {/* Contacto FreshDesk */}
            <p style={{    textAlign: "center", marginTop: "50px"}}>
              Si tienes más dudas o necesitas ayuda, puedes contactarnos en  
              <a href="mailto:atendimento@payretailers.com"> atendimento@payretailers.com</a>. 
            </p>
          </Content>
        </Flex>
      </div>
      <Footer>
        <FooterComp page={'contact'} lang={lang}/>
      </Footer>
    </>
  );
}

export default Faqs